import React from "react";
import moment from "moment";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postGateForm } from "../../redux/actions/gateActions";
import HorizontalLine from "../../common/HorizontalLine";

const EmploymentApplicationForm = ({ appData, postGateFormFunc }) => {
  const {
    firstName = "",
    lastName = "",
    homeTelephone = "",
    mobileTelephone,
    emailAddress,
    address: {
      addressLine1 = "",
      addressLine2 = "",
      addressLine3 = "",
      town = "",
      postcode = "",
    },
  } = appData;

  let initialData = {
    firstName,
    lastName,
    postcode,
    homeTelephone,
    emailAddress,
    mobileTelephone,
    dateOfBirth: appData.dateOfBirth
      ? moment(appData.dateOfBirth).format("DD/MM/YYYY")
      : "",
    address:
      addressLine1 +
      (addressLine2 ? `, ${addressLine2}` : "") +
      (addressLine3 ? `, ${addressLine3}` : "") +
      (town ? `, ${town}` : ""),
  };

  if (appData && appData.gateOnboarding && appData.gateOnboarding.application) {
    initialData = {
      ...initialData,
      ...appData.gateOnboarding.application,
    };
  }

  const getVal = getField(initialData);

  const initialState = {
    EmploymentApplication1: {
      title: "Position Applied For",
      value: getVal("EmploymentApplication1"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication2: {
      title: "Location",
      value: getVal("EmploymentApplication2"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication3: {
      title: "First Name",
      value: getVal("firstName"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication4: {
      title: "Surname",
      value: getVal("lastName"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication5: {
      title: "Previous name/s that you have been known by",
      value: getVal("EmploymentApplication5"),
      type: "text",
      mandatory: false,
    },
    EmploymentApplication7: {
      title: "Home Address",
      value: getVal("address"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication6: {
      title: "Post Code",
      value: getVal("postcode"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication8: {
      title: "National Insurance Number",
      value: getVal("EmploymentApplication8"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication9: {
      title: "E-Mail Address",
      value: getVal("emailAddress"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication10: {
      title: "Contact Telephone Number",
      value: getVal("mobileTelephone"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication11: {
      title: "Date of Birth",
      value: getVal("dateOfBirth"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication12: {
      title:
        "Are you happy to commit to working evenings and weekends as part of a shift rota?",
      value: getVal("EmploymentApplication12"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication13: {
      title:
        "Are you looking for Full Time (40 hours per week) or Part Time work?",
      value: getVal("EmploymentApplication13"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "Full Time", value: "FULL TIME" },
        { label: "Part Time", value: "PART TIME" },
      ],
    },
    EmploymentApplication14: {
      title:
        "Number of days and hours per week that you are available to work?",
      value: getVal("EmploymentApplication14"),
      type: "text",
      mandatory: true,
    },
    EmploymentApplication15: {
      title: "Do you hold a full and current driving licence?",
      value: getVal("EmploymentApplication15"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication16: {
      title: "Do you hold a full and current HGV licence?",
      value: getVal("EmploymentApplication16"),
      type: "checkbox",
      mandatory: false,
    },
    EmploymentApplication17: {
      title: "If yes what category?",
      value: getVal("EmploymentApplication17"),
      type: "text",
      mandatory: true,
      dependOn: [{ fieldKey: "EmploymentApplication16" }],
    },
    EmploymentApplication18: {
      title: "If yes, what date did you pass your LGV test?",
      value: getVal("EmploymentApplication18"),
      type: "text",
      mandatory: true,
      dependOn: [{ fieldKey: "EmploymentApplication16" }],
    },
    EmploymentApplication19: {
      title:
        "Do you have an initial CPC qualification? (Drivers qualified after 10.09.09 only)",
      value: getVal("EmploymentApplication19"),
      type: "text",
      mandatory: false,
    },
    EmploymentApplication20: {
      title:
        "Do you have any hours which contribute to your 35-hour CPC training qualification required by Sep 2019?",
      value: getVal("EmploymentApplication20"),
      type: "text",
      mandatory: false,
    },
    EmploymentApplication21: {
      title: "Do you suffer from colour blindness?",
      value: getVal("EmploymentApplication21"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication22: {
      title:
        "Are there any restrictions to your residence in the UK which might affect your right to take up employment in the UK?",
      value: getVal("EmploymentApplication22"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication23: {
      title: "If Yes, please provide details:",
      value: getVal("EmploymentApplication23"),
      type: "text",
      mandatory: true,
      dependOn: [{ fieldKey: "EmploymentApplication22" }],
    },
    EmploymentApplication24: {
      title:
        "Please tick which document you would be able to provide to determine proof of eligibility to work in the UK should an offer of employment be made to you:",
      value: getVal("EmploymentApplication24"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "UK Passport", value: "UK Passport" },
        { label: "EU Passport", value: "EU Passport" },
        { label: "Visa/Residency Permit", value: "Visa/Residency Permit" },
        { label: "National ID Card", value: "National ID Card" },
        { label: "Long Birth Certificate", value: "Long Birth Certificate" },
      ],
    },
    EmploymentApplication25: {
      title:
        "If you are successful in your application, would you require a work permit prior to taking up employment?",
      value: getVal("EmploymentApplication25"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication26: {
      title: "IMPORTANT - PLEASE READ",
      type: "heading",
      textDescription: [
        "Your role may involve you carrying out tasks which are classified as being a security function. Where this is the case, you will be required to undergo a Criminal Record Check. The Civil Aviation Authority govern the industry in which Gate Group operates and they provide a list of disqualified convictions which can be found by visiting their website: http://www.caa.co.uk/default.aspx?catid=2780&pageid=15971",
        "Consequently, if you were to have one of these convictions listed as part of your CRC, we would be unable to employ you. To reassure you, you should not assume that if you do have a conviction, it will mean that we are unable to employ you. Gate Group will comply fully with the Rehabilitation of Offenders Act 1974. .",
        "Please note that if you have been out of the UK for 6 months or more in a particular country within the last 5 years you must also apply to that country for a CRC. Please liaise with HR who will support you in this process.",
        "You must provide details of any offence for which you may go to court for or are awaiting a hearing. This includes you have been arrested and are waiting to hear if you will be formally charged",
      ],
    },
    Heading4: {
      htmlObj: (
        <div>
          <HorizontalLine text={"How Do I Know If My Conviction Is Spent?"} />
          For further information on how to determine whether a conviction is
          spent please visit the Unlock website:{" "}
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://hub.unlock.org.uk/knowledgebase/spent-now-brief-guide-changes-roa/"
            >
              http://hub.unlock.org.uk/knowledgebase/spent-now-brief-guide-changes-roa/
            </a>
          </span>
        </div>
      ),
    },
    EmploymentApplication27: {
      title:
        "Do you have any criminal convictions which are not yet ‘spent’ under the Offenders Act 1974?",
      value: getVal("EmploymentApplication27"),
      type: "checkbox",
      mandatory: true,
    },
    EmploymentApplication28: {
      title:
        "If you have any criminal convictions which are not yet “spent” under the Rehabilitation of Offenders Act 1974, please give details and dates below:",
      value: getVal("EmploymentApplication28"),
      type: "textarea",
      mandatory: true,
      dependOn: [{ fieldKey: "EmploymentApplication27" }],
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postGateFormFunc("application", {
      ...fieldValuesPayload,
    });

    history.push("/profile/edit/gate-group-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Employment Application"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/gate-group-onboarding")}
      onboardingBranch={"#ADD_BRANCH#"} // <-- TODO
    />
  );
};

EmploymentApplicationForm.propTypes = {
  appData: any,
  postGateFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  postGateFormFunc: postGateForm,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(EmploymentApplicationForm);
